import {mapGetters, mapMutations} from 'vuex';
import VueSlideUpDown from 'vue-slide-up-down'

export default {
    name: 'sidebar-mobile',
    data() {
        return {
            active: false,
        }
    },
    components: {
        VueSlideUpDown,
    },
    watch: {
        '$route'() {
            this.changeMobileMenu(false);
        }
    },
    computed: {
        ...mapGetters({
            navigation: 'system/navigation',
            openMobileMenu: 'system/openMenu',
            userHomework: 'userHomework/list',
            setting: 'setting/setting',
        }),
        shopLink() {
            return this.setting && this.setting.storeLink ? this.setting.storeLink : 'https://genius.space/nashi-programmy-obucheniya/';
        },
        isCourseRoute() {
            return this.$route.fullPath.includes('/courses/')
        },
    },
    methods: {
        ...mapMutations({
            changeMobileMenu: 'system/CHANGE_MOBILE_MENU'
        }),
    }
}
